import { arraysEqual } from '../../../../utilities'

export const initialState = {
  tags: [],
  tag: '',
  startingTag: '',
  changed: false,
  editing: false,
  cache: new Map()
}

export const Actions = {
  SET_TAGS: 'SET_TAGS',
  TAG_CHANGED: 'TAG_CHANGED',
  ADD: 'ADD',
  DELETE: 'DELETE',
  SWITCH: 'SWITCH',
  UPLOAD_DONE: 'UPLOAD_DONE',
  SAVE: 'SAVE',
  LOAD: 'LOAD'
}

export const tagReducer = (state, action) => {
  const { type } = action

  switch (type) {
    case Actions.SET_TAGS:
      return handleSetTags(state, action)
    case Actions.TAG_CHANGED:
      return handleTagChange(state, action)
    case Actions.ADD:
      return handleAdd(state, action)
    case Actions.DELETE:
      return handleDelete(state, action)
    case Actions.SWITCH:
      return handleSwitch(state, action)
    case Actions.UPLOAD_DONE:
      return handleUploadDone(state, action)
    case Actions.SAVE:
      return handleSave(state, action)
    case Actions.LOAD:
      return handleLoad(state, action)
    default:
      throw new Error(`Unknown tag reducer type: ${type}`)
  }
}

const handleSetTags = (state, action) => {
  const { tags } = action

  const { cache: oldCache } = state

  return { ...initialState, tags, cache: new Map(oldCache) }
}

const handleTagChange = (state, action) => {
  const { tag } = action

  return { ...state, tag }
}

const handleAdd = (state, action) => {
  const { tag } = action
  const trimmed = tag.trim()

  if (!trimmed.length) {
    return {
      ...state,
      tag: '',
      startingTag: '',
      changed: false,
      editing: false
    }
  }

  let tags = [...new Set([...state.tags, trimmed])]
  if (state.editing) {
    tags = tags.filter(tag => tag !== state.startingTag)
  }

  return {
    ...state,
    tags,
    tag: '',
    startingTag: '',
    changed: !arraysEqual(state.tags, tags),
    editing: false
  }
}

const handleDelete = (state, action) => {
  const { tag } = action
  const tags = state.tags.slice().filter(t => t !== tag)

  return { ...state, tags, changed: true }
}

const handleSwitch = (state, action) => {
  const { tag } = action

  return { ...state, tag, startingTag: tag, editing: true }
}

const handleUploadDone = (state, action) => {
  return { ...state, changed: false }
}

const handleSave = (state, action) => {
  const { userID } = action

  const { cache: oldCache, ...rest } = state
  const cache = new Map(oldCache)
  cache.set(userID, rest)

  return { ...state, cache }
}

const handleLoad = (state, action) => {
  const { userID } = action

  const { cache, ...rest } = state
  let newState = { ...initialState }
  if (cache.has(userID)) {
    newState = cache.get(userID)
  } else {
    cache.set(userID, rest)
  }

  return { ...newState, cache: new Map(cache) }
}
